export default __webpack_public_path__ + "static/Mathilde-837530d37994ca8e252d7ffea7f7094b.webp";